import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';

import {XmlResponse} from '../../../models/api-xml-2/xml-2/xml-2-response.model';

@Injectable({
    providedIn: 'root'
})
export class XmlRedService {

    importUrl: string = environment.backend.pathUrl.store.import_xml_red;
    exportUrl: string = environment.backend.pathUrl.store.export_xml_red;
    baseUrl: string = environment.backend.baseUrl_location;
    key: string = environment.key_location_api
    importFullPath: string = this.baseUrl + this.importUrl;
    exportFullPath: string = this.baseUrl + this.exportUrl;

    constructor(
        private http: HttpClient
    ) {
    }

    /**Import
     *
     * @param request
     * @param file
     * @returns Observable XmlResponse
     */
    import(file: File): Observable<XmlResponse> {
        const url = this.importFullPath;
        let headers = new HttpHeaders();
        headers = headers.append('Accept', 'application/json');
        const formData = new FormData();
        formData.append('file', file);
        formData.append('key', this.key);
        return this.http.post<XmlResponse>(url, formData, {headers});
    }

    export(): Observable<Blob> {
        const url = this.exportFullPath;
        const headers = new HttpHeaders({
            Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const params = new HttpParams().set('key', this.key);

        return this.http.get(url, {headers, params, responseType: 'blob'});
    }
}
